import Notification from '@rio-cloud/rio-uikit/Notification';
import type { IntlShape } from 'react-intl';

export const handleNotificationForUpdateData = (intl: IntlShape) => {
    Notification.info(
        intl.formatMessage({
            id: 'intl-msg:ordercom-cloud-frontend.notification.data.update.success',
        })
    );
};
